import { render, staticRenderFns } from "./CustomersAutocomplete.vue?vue&type=template&id=9660d974&scoped=true"
import script from "./CustomersAutocomplete.vue?vue&type=script&lang=js"
export * from "./CustomersAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9660d974",
  null
  
)

export default component.exports